// ──────────────────────────────────────────────
// GeoDrops — Category Filter Bar
// Neon Navigator: glass chips, no borders.
// ──────────────────────────────────────────────

import type { PinCategory } from "@/types";
import { CATEGORIES } from "@/types";
import { hapticImpact } from "@/lib/telegram";

interface CategoryFilterProps {
  active: PinCategory | null;
  onChange: (category: PinCategory | null) => void;
}

export function CategoryFilter({ active, onChange }: CategoryFilterProps) {
  return (
    <div
      style={{
        position: "absolute",
        top: "calc(env(safe-area-inset-top, 0px) + 12px)",
        left: 0,
        right: 0,
        zIndex: 1000,
        padding: "0 12px",
        display: "flex",
        gap: 8,
        overflowX: "auto",
        WebkitOverflowScrolling: "touch",
        scrollbarWidth: "none",
        msOverflowStyle: "none",
      }}
    >
      {/* All chip */}
      <button
        onClick={() => { onChange(null); hapticImpact("light"); }}
        style={{
          flexShrink: 0,
          padding: "8px 16px",
          borderRadius: 9999,
          border: "none",
          background: active === null
            ? "linear-gradient(135deg, #85adff, #6c9fff)"
            : "rgba(14,27,76,0.8)",
          backdropFilter: "blur(20px)",
          WebkitBackdropFilter: "blur(20px)",
          color: active === null ? "#002c65" : "#e1e4ff",
          fontSize: 12,
          fontWeight: 700,
          cursor: "pointer",
          boxShadow: "0 4px 16px rgba(0,0,0,0.3)",
          whiteSpace: "nowrap",
          textTransform: "uppercase",
          letterSpacing: "0.05em",
        }}
      >
        All Drops
      </button>

      {CATEGORIES.map((cat) => (
        <button
          key={cat.key}
          onClick={() => { onChange(active === cat.key ? null : cat.key); hapticImpact("light"); }}
          style={{
            flexShrink: 0,
            padding: "8px 16px",
            borderRadius: 9999,
            border: active === cat.key ? `1px solid ${cat.color}40` : "1px solid rgba(61,70,108,0.2)",
            background: active === cat.key ? cat.color : "rgba(14,27,76,0.8)",
            backdropFilter: "blur(20px)",
            WebkitBackdropFilter: "blur(20px)",
            color: active === cat.key ? "#020a2f" : "#e1e4ff",
            fontSize: 12,
            fontWeight: 600,
            cursor: "pointer",
            boxShadow: "0 4px 16px rgba(0,0,0,0.3)",
            whiteSpace: "nowrap",
            display: "flex",
            alignItems: "center",
            gap: 6,
          }}
        >
          {cat.emoji} {cat.label}
        </button>
      ))}
    </div>
  );
}
